import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-info-circle',
  templateUrl: './info-circle.component.html',
  styleUrls: ['./info-circle.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoCircleIconComponent {}
